import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	buttonIsDisabled:true,
    insuredChildren:[
      {
        name:'',
        date:''
      },
    ],
    adult:{
      name:'',
      date:''
    },
  	insurerName: '',
    agreement:false,
   //  insurerGender: '',
  	birthDate: '',
    popupIsActive:false,
  	passport: '',
  	address: '',
  	phone: '',
  	mail: '',
  	// polisDate: '',
  	insuredPeople:[
  		{
  			FIO:'',
	  		BIRTHDAY:'',
        id:0
  		},
      {
        FIO:'',
        BIRTHDAY:'',
        id:1
      },
      {
        FIO:'',
        BIRTHDAY:'',
        id:2
      },
  	],
    selectedProgram:'base',
    programms:[
      {
        value:'base',
        text:'Индивидуальный',
        type:1,
        price:'3 435',
        desc:'Программа идеально подойдёт для собственной финансовой защиты',
        texts:[
          {
            title:'Будет застрахован:',
            texts:[
              {
                text:'1 взрослый в возрасте от 18 до 65 лет',
                hasTooltip:false,
                tooltipText:'текст тултипа'
              },
            ],
          },
          {
            title:'По рискам:',
            texts:[
              {
                text:'Временная нетрудоспобность в результате болезни - 5 000 ₽',
                hasTooltip:true,
                tooltipText:'Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-СoV-2)'
              },
              {
                text:'Госпитализация - 1 400 ₽ за каждый день госпитализации (максимальная выплата 35 000 ₽)',
                hasTooltip:true,
                tooltipText:'Госпитализация Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) из расчета 1 400 руб./день с 1 дня, но не более 35 000 руб.'
              },
              {
                text:'Смерть в результате болезни - 500 000 ₽',
                hasTooltip:true,
                tooltipText:'Смерть Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2))'
              },


            ],
          },
        ],
        options:[
          {
            text:'Выплата до 500 000₽ в случае смерти застрахованного'
          },
          {
            text:'Выплата до 35 000₽ застрахованному в случае Госпитализации'
          },
          {
            text:'Выплата 5 000₽ при временной нетрудоспособности'
          },
          {
            text:'Возраст застрахованного ограничен от 18 до 65 лет'
          },
          {
            text:'Территория страхования только РФ'
          },
          {
            text:'Срок страхования 1 год'
          },
          {
            text:'Полис начинает действовать на 15 день с момента оплаты'
          },
        ]
      },
      {
        value:'family',
        text:'Семейный',
        type:2,
        price:'11 862',
        desc:'Программа идеально подойдет для Вас и Вашей семьи',

        texts:[
          {
            title:'Будут застрахованы:',
            texts:[
              {
                text:'Вся семья: родители + все дети',
                hasTooltip:false,
                tooltipText:'текст тултипа'
              },
            ],
          },
          {
            title:'По рискам:',
            texts:[
              {
                text:'Временная нетрудоспобность в результате болезни – 5 000 ₽',
                hasTooltip:true,
                tooltipText:'Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-СoV-2)'
              },
              {
                text:'Госпитализация - 1 400 ₽ за каждый день госпитализации (максимальная выплата 35 000 ₽)',
                hasTooltip:true,
                tooltipText:' Госпитализация Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) из расчета 1 400 руб./день с 1 дня, но не более 35 000 руб. '
              },
              {
                text:'Смерть в результате болезни - 500 000 ₽ (максимальная выплата 1 000 000 ₽)',
                hasTooltip:true,
                tooltipText:' Смерть Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)). Не более 500 000₽ на одного застрахованного.'
              },
            ],
          },
        ],
        options:[
          {
            text:'Выплата до 500 000₽ в случае смерти застрахованного'
          },
          {
            text:'Выплата до 35 000₽ каждому застрахованному в случае Госпитализации'
          },
          {
            text:'Выплата 5 000₽ при временной нетрудоспособности'
          },
          {
            text:'Застраховано 2 взрослых и дети',
            hasTooltip:true,
            tooltipText:'2 взрослых в возрасте от 18 до 65 лет. Неограниченное кол-во детей в возрасте от 1 года до 17 лет.'
          },
          {
            text:'Территория страхования только РФ'
          },
          {
            text:'Срок страхования 1 год'
          },
          {
            text:'Полис начинает действовать на 15 день с момента оплаты'
          },
        ]
      },
      // {
      //   value:'base-prem',
      //   text:'Индивидуальный расширенный',
      //   type:1,
      //   price:'2 700',
      //   desc:'Программа финансовой зашиты с высокими лимитами покрытия',

      //   texts:[
      //     {
      //       title:'Будет застрахован:',
      //       texts:[
      //         {
      //           text:'1 взрослый в возрасте от 18 до 65 лет',
      //           hasTooltip:false,
      //           tooltipText:'текст тултипа'
      //         },
      //       ],
      //     },
      //     {
      //       title:'По рискам:',
      //       texts:[
      //         {
      //           text:'Установление диагноза Коронавирусная инфекция COVID-19 - 30 000 ₽',
      //           hasTooltip:true,
      //           tooltipText:'Временная нетрудоспособность в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) - факт установления диагноза.'
      //         },
      //         {
      //           text:'Госпитализация - 5 000 ₽ за каждый день нахождения в стационаре (максимальная выплата 100 000 ₽)',
      //           hasTooltip:true,
      //           tooltipText:' Госпитализация Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) из расчета 5 000 руб./день с 1 дня, но не более 100 000 руб.'
      //         },
      //         {
      //           text:'Смерть в результате Коронавирусная инфекция COVID-19 - 1 000 000 ₽',
      //           hasTooltip:true,
      //           tooltipText:'Смерть Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)).'
      //         },

      //       ],
      //     },
      //   ],
      //   options:[
      //     {
      //       text:'Выплата до 1 000 000₽ в случае смерти застрахованного'
      //     },
      //     {
      //       text:'Выплата до 100 000₽ застрахованному в случае Госпитализации'
      //     },
      //     {
      //       text:'Выплата 30 000₽ при установлении диагноза COVID-19'
      //     },
      //     {
      //       text:'Возраст застрахованного ограничен от 18 до 65 лет'
      //     },
      //     {
      //       text:'Территория страхования только РФ'
      //     },
      //     {
      //       text:'Срок страхования 1 год'
      //     },
      //     {
      //       text:'Полис начинает действовать на 8 день с момента оплаты'
      //     },
      //   ]
      // },
      // {
      //   value:'family-prem',
      //   text:'Семейный расширенный',
      //   price:'5 700',
      //   desc:'Эксклюзивное предложение для защиты Вашей семьи',
      //   type:2,
      //   texts:[
      //     {
      //       title:'Будут застрахованы:',
      //       texts:[
      //         {
      //           text:'Вся семья: родители + все дети',
      //           hasTooltip:false,
      //           tooltipText:'текст тултипа'
      //         },
      //       ],
      //     },
      //     {
      //       title:'По рискам:',
      //       texts:[
      //         {
      //           text:'Установление диагноза Коронавирусная инфекция COVID-19 - 30 000 ₽',
      //           hasTooltip:true,
      //           tooltipText:'Временная нетрудоспособность в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) - факт установления диагноза.'
      //         },
      //         {
      //           text:'Госпитализация - 5 000 ₽ за каждый день нахождения в стационаре (максимальная выплата 100 000 ₽)',
      //           hasTooltip:true,
      //           tooltipText:'Госпитализация Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)) из расчета 5 000 руб./день с 1 дня, но не более 100 000 руб.'
      //         },
      //         {
      //           text:'Смерть в результате Коронавирусная инфекция COVID-19 - 2 000 000 ₽',
      //           hasTooltip:true,
      //           tooltipText:'Смерть Застрахованного в результате болезни (вирусное заболевание – Коронавирусная инфекция COVID-19 – Атипичная пневмония нового типа (штамм SARS-CoV-2)). Не более 1000 000₽ на одного застрахованного.'
      //         },


      //       ],
      //     },
      //   ],
      //   options:[
      //     {
      //       text:'Выплата до 1 000 000₽ в случае смерти застрахованного'
      //     },
      //     {
      //       text:'Выплата до 100 000₽ застрахованному в случае Госпитализации'
      //     },
      //     {
      //       text:'Выплата 30 000₽ при установлении диагноза COVID-19'
      //     },
      //     {
      //       text:'Застраховано 2 взрослых и дети',
      //       hasTooltip:true,
      //       tooltipText:'2 взрослых в возрасте от 18 до 65 лет. Неограниченное кол-во детей в возрасте от 1 года до 17 лет.'
      //     },
      //     {
      //       text:'Территория страхования только РФ'
      //     },
      //     {
      //       text:'Срок страхования 1 год'
      //     },
      //     {
      //       text:'Полис начинает действовать на 8 день с момента оплаты'
      //     },
      //   ]
      // },
    ],
  	Schema:{
  		mail:{
				placeholder:'Электронная почта',
				name:'mail',
				mask:'',
				validateRules:{
					required: true,
          email: true
				}
			},

			agreement:{
        text:'Нажимая кнопку оплатить, Вы соглашаетесь с политикой обработки персональных данных, правилами страхования, с дополнительными условиями и подтверждаете, что не относитесь к категории ИПДЛ/РПДЛ, являетесь владельцем платежной карты, с которой производится оплата страховой премии.',
        name:'agreement',
        validateRules:{
          required: true,
        }
      },
  		phone:{
				placeholder:'Телефон',
				name:'phone',
				mask: '+7 (999) 999 99 99',
				validateRules:{
					required: true,
					regex: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/
				}
			},

      adultName:{
        placeholder:'Фамилия, Имя и Отчество',
        name:'adultName',
        getter:'adultName',
        setter:'adultName',
        mask:'',
        validateRules:{
          required:false
        }
      },
			insurerName:{
				placeholder:'Фамилия, Имя и Отчество',
				name:'insurerName',
				getter:'getInsurerName',
				setter:'insurerName',
				mask:'',
				validateRules:{
					required:true
				}
			},
      adultBirthDate:{
        placeholder:'Дата рождения',
        name:'adultBirthDate',
        getter:'getBirthDate',
        setter:'birthDate',
        mask:'99.99.9999',
        validateRules:{
          required:false,
          date_format: 'dd.MM.yyyy',
          yearsMin18: true,
          // yearsMax17: true,
        }
      },
			birthDate:{
				placeholder:'Дата рождения',
				name:'insurerBirthDate',
				getter:'getBirthDate',
				setter:'birthDate',
				mask:'99.99.9999',
				validateRules:{
					required:true,
					date_format: 'dd.MM.yyyy',
          yearsMin18: true,
				}
			},
			passport:{
				placeholder:'Серия и номер паспорта',
				name:'passport',
				mask:'9999 999999',
				validateRules:{
					regex:/\d{4}.{1}\d{6}/,
					required:true,

					// length:10,
					// numeric:true
				}
			},
			address:{
				placeholder:'Адрес проживания',
				name:'address',
				getter:'getAddress',
				setter:'address',
				mask:'',
				validateRules:{
					required:true,
				}
			},
			insuredPeopleName:{
				placeholder:'Фамилия Имя Отчество',
				name:'insuredPeople',
				mask:'',
				validateRules:{
					required:false,

				}
			},
			insuredPeopleBirthDate:{
				placeholder:'Дата рождения',
				name:'birthDate',
				mask:'99.99.9999',
				validateRules:{
					required:false,
					date_format: 'dd.MM.yyyy',
          // yearsMin18: true,
          yearsMax17: true,
				}
			},
  	}
  },
  getters:{
    getRequestData(state) {
      const selectedProgramm = state.programms.find(item => item.value === state.selectedProgram)
      const programPrice = selectedProgramm.price.replace(' ', '');

      if(selectedProgramm.type === 2) {
        const children = state.insuredChildren
        const adult = state.adult
        var insured_fio = [
          adult.name,
          ...children.map(item => item.name)
        ]
        var insured_birthday = [
          adult.date,
          ...children.map(item => item.date)
        ]
      }
      const data = {
        summ_back:programPrice,
        insurer_passport:state.passport,
        insurer_fio:state.insurerName,
        insurer_birthday:state.birthDate,
        insurer_phone:state.phone,
        insurer_email:state.mail,
        insurer_address:state.address,
        insured_fio,
        insured_birthday,
        package:selectedProgramm.text
      }
      return data
    },
  	getIsLoading(state) {
  		return state.isLoading;
  	},

  	getMail(state) {
  		return state.mail;
  	},
  	getPhone(state) {
  		return state.phone;
  	},
  	getSchema(state) {
  		return state.Schema;
  	},
  	getInsurerName(state) {
  		return state.insurerName;
  	},
  	getBirthDate(state) {
  		return state.birthDate;
  	},
  	getPassport(state) {
  		return state.passport;
  	},
  	getAddress(state) {
  		return state.address;
  	},
  	getInsuredPeople(state) {
  		return state.insuredPeople;
  	},

  	getField
  },
  mutations: {
  	updateField,
  	setIsLoading(state, payload){
      state.isLoading = payload
    }
  },
  actions: {
  	sendData({getters, commit, dispatch}) {

  		const data = getters.getRequestData
  		const settings = {
  			type:'anticorona_digital',
  			send: 'y',
        ...data
	  	}
	  	commit('setIsLoading', true);
  		// axios.post('https://zetta-6.air-dev.agency/.ajax/order.php', settings, {
      axios.post('/.ajax/order.php', settings, {
				headers:{
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
			.then((response) => {
				if(response.status == 200) {
						return response;
				}
				throw new Error('Network response was not ok');
			})
			.then((json) => {
				if(json.data.redirect) {
					window.location.href = json.data.redirect;
					// console.log(json.data)
				}
				commit('setIsLoading', false);
			})
			.catch((error) => {
					console.log(error);
			});
  	},
    checkPermission({getters, commit, dispatch, state}) {
      const insurerName = `${state.insurerName} ${state.birthDate}`
      const settings = {
        antivip:[insurerName]
      }
      const selectedProgramm = state.programms.find(item => item.value === state.selectedProgram)
      if (selectedProgramm.type === 2) {
        const children = state.insuredChildren
        const adult = `${state.adult.name} ${state.adult.date}`
        const childrenNames = children.map(el => {
          return `${el.name} ${el.date}`
        })
        var insured_fio = [
          adult,
          ...childrenNames
        ]
        settings.antivip = [...settings.antivip, ...insured_fio]
      }
      const formData = new FormData();
      settings.antivip.forEach((item, i) => {
        formData.append(`antivip[${i}]`, item);
      })

      commit('setIsLoading', true);
      // axios.post('https://zetta.air-dev.agency/.ajax/order.php', settings, {
      return axios.post('/.ajax/permission-to-purchase.php', formData, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then((response) => {
        if (response.status == 200) {
          return response;
        }
        throw new Error('Network response was not ok');
      })
      .then((json) => {
        commit('setIsLoading', false);
        return json.data
      })
      .catch((error) => {
        console.log(error);
      });
    },
  	// getData({getters, commit, dispatch}){
  	// 	const settings = {
  	// 		action:'getData'
	  // 	}
  	// 	axios.post('https://zetta-2.air-dev.agency/calculators/ns-sport/ajax.php', settings, {
			// 	headers:{
			// 		'X-Requested-With': 'XMLHttpRequest'
			// 	}
			// })
			// .then((response) => {
			// 	if(response.status == 200) {
			// 			return response;
			// 	}
			// 	throw new Error('Network response was not ok');
			// })
			// .then((json) => {
			// 		console.log(json.data)
			// 		commit('setSportList', json.data.CalcNsSportActivitiesList)
			// 		commit('setSportTariffs', json.data.CalcNsSportTariffs)
			// })
			// .catch((error) => {
			// 		console.log(error);
			// });
  	// },
  	sports({commit}, payload){
  		commit('setSelectedSports', payload);
  	},
  	maxCategory({commit, getters}, payload){
  		let category = 1;
      selectedSports.forEach((el) => {
        if(parseInt(el.UF_CATEGORY) > category) {
          category = parseInt(el.UF_CATEGORY);
        }
      })
  		commit('setMaxCategory', payload);
  	},
  	insurerName({commit}, payload){
  		commit('setInsurerName', payload);
  	},
  	term({commit}, payload){
  		commit('setTerm', payload);
  	},
  	sum({commit}, payload){
  		commit('setSum', payload);
  	},
  	count({commit}, payload){
  		commit('setCount', payload);
  	},
  	birthDate({commit}, payload){
  		commit('setBirthDate', payload);
  	},
  	passport({commit}, payload){
  		commit('setPassport', payload);
  	},
  	address({commit}, payload){
  		commit('setAddress', payload);
  	},
  	setInsuredPeopleCount({getters, commit, dispatch}){
  		let count = getters.getCount.value;
  		let insuredPeople = []
  		for(let i = 0; i < count; i++) {
	  		insuredPeople[i] = {
	  			FIO:'',
	  			BIRTHDAY:'',
          SEX:''
	  		}
	  	}
  		commit('setInsuredPeople', insuredPeople);
  	},
  }
})
